module.exports = __webpack_public_path__ + "img/OurEvaluationQuotes-01.ec545403.svg";